import {useMutation} from 'react-query';
import {IPostSendOtpCodePayload, postSendOtpCode} from './postSendOtpCode';

const usePostSendOtpCode = () => {
  const {mutate, isLoading, data} = useMutation({
    mutationFn: (payload: IPostSendOtpCodePayload) => postSendOtpCode(payload),
  });

  return {mutate, isLoading, data};
};

export default usePostSendOtpCode;
